import React, { useContext, useMemo, useState } from "react"
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  CardContent,
} from "@material-ui/core"
import GreenButton from "../../Common/GreenButton/index"
import { useDispatch, useSelector } from "react-redux"
import {
  toggleSendBillingDialog,
  toggleClickConfirmationDialog,
} from "../../../../actions/billingDialogs"
import useStyles from "./styles"
import InvoiceStatusCard from "../InvoiceStatusCard/index"
import { openSnackBar } from "../../../../actions/snack-bar"
import { updateDealMemoClientStatus } from "../../../../actions/billing"
import moment from "moment"
import NextStep from "../../../NextStep/index"
import BillingContext from "../../../../pages/Shoot/pages/Billing/BillingContext"
import BillingClientTerms from "../BillingClientTerms/index"
import LoadingButton from "../../../LoadingButton/index"

const InvoiceRight = props => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [sendLoading, setSendLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  const billingContext = useContext(BillingContext)
  let shootId = props.match.params.shoot_id

  const generalData = useSelector(state => state.billing.generalData)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const invoiceSent = generalData && Boolean(generalData.invoice_sent)
  const invoiceAccepted = generalData && Boolean(generalData.invoice_accepted)

  // *** SEND INVOICE  ***
  const handleSendInvoice = dialogVals => {
    setSendLoading(true)
    const requestData = {
      action_type: "invoice",
      email_to: dialogVals.recipients.join(", "),
      subject: dialogVals.subject,
      message: dialogVals.message,
    }
    dispatch(updateDealMemoClientStatus(requestData, shootId, "sent"))
      .then(() => {
        dispatch(openSnackBar({ message: "Sent Invoice to Client" }))
        setSendLoading(false)
      })
      .catch(err => {
        console.log(err)
        setSendLoading(false)
        dispatch(openSnackBar({ message: "Error sending Invoice to client" }))
      })
  }

  const openSendDialog = () => {
    let firstValidEmail =
      generalData.invoice_sent_to ||
      generalData.estimate_sent_to ||
      generalData.client_email

    let defaultEmail = firstValidEmail
      ? firstValidEmail.split(",").map(x => x.trim())
      : null
    let dialogData = {
      type: "Invoice",
      shootName: generalData.name,
      defaultEmail: defaultEmail,
      sendFunc: handleSendInvoice,
    }
    dispatch(toggleSendBillingDialog(true, dialogData))
  }

  const openConfirmation = () => {
    let data = {
      action: "confirm and send invoice to client without saving",
      confirmationFunc: openSendDialog,
    }
    billingContext.setUnsavedErrorBorder(true)
    dispatch(toggleClickConfirmationDialog(true, data))
  }
  // *** SEND INVOICE END ***

  const startDate = moment(generalData.start_date).format("MMM Do YYYY")
  const daysAway = moment(generalData.start_date)
    .startOf("day")
    .fromNow()

  const nextStepMessage = useMemo(() => {
    let message = " "
    if (generalData.billing_step_name === "Deal Memo") {
      message =
        "Once all crew members have accepted their deal memos, the shoot will be booked."
    } else if (generalData.billing_step_name === "Estimate") {
      message =
        "Once the shoot has wrapped, each crew member will submit any additional shoot expenses for you to review."
    } else if (generalData.billing_step_name === "Bill Approval") {
      message =
        "Once the client has accepted your additional expenses and paid in full, your shoot payment will be transferred."
    } else if (generalData.billing_step_name === "Invoice") {
      message =
        "Please accept and pay this invoice in a timely manner so that we may submit payment to the shoot crew."
    } else {
      message = "Not a valid shoot"
    }
    return message
  })

  // *** APPROVE INVOICE  ***

  const handleApproveInvoice = () => {
    setActionLoading(true)
    let actionData = {
      url_type: "accepted",
      type: "invoice",
      client_invoice_signature: `${authenticatedUser.first_name} ${authenticatedUser.last_name
        } (Admin)`,
    }
    dispatch(updateDealMemoClientStatus(actionData, shootId, "approve"))
      .then(() => {
        setActionLoading(false)
        dispatch(openSnackBar({ message: "You have approved this invoice!" }))
      })
      .catch(err => {
        console.log(err)
        setActionLoading(false)
        dispatch(openSnackBar({ message: "Error approving invoice" }))
      })
  }

  const confirmAcceptDialog = () => {
    let confirmationData = {
      confirmationFunc: handleApproveInvoice,
      action: "accept this invoice",
    }
    dispatch(toggleClickConfirmationDialog(true, confirmationData))
  }

  // *** APPROVE INVOICE  END***

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {!invoiceSent && (
        <Typography
          style={{
            fontSize: "16px",
            fontWeight: 600,
            alignSelf: "flex-start",
            margin: "10px 0",
          }}
        >
          Client Terms
        </Typography>
      )}
      <Card className={classes.card}>
        <CardContent>
          {!invoiceSent && !invoiceAccepted ? (
            <BillingClientTerms data={generalData} />
          ) : (
            <InvoiceStatusCard />
          )}
        </CardContent>
      </Card>
      <Box mt={3} width="80%">
        <GreenButton
          fullWidth
          variant="contained"
          disabled={sendLoading}
          // onClick={openSendDialog}
          onClick={
            billingContext.unsavedState.length > 0
              ? openConfirmation
              : openSendDialog
          }
        >
          {sendLoading ? (
            <CircularProgress
              size={25}
              style={{ color: "#fff", marginTop: "2px", marginBottom: "2px" }}
            />
          ) : invoiceSent ? (
            "Resend Invoice to Client"
          ) : (
            "Send Invoice to Client"
          )}
        </GreenButton>
        {!invoiceAccepted && (
          <Box mt={3} mb={3}>
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={confirmAcceptDialog}
              fullWidth
              disabled={actionLoading}
            >
              {actionLoading ? (
                <CircularProgress
                  size={25}
                  style={{
                    color: "#fff",
                    marginTop: "2px",
                    marginBottom: "2px",
                  }}
                />
              ) : (
                "Accept Invoice"
              )}
            </LoadingButton>
          </Box>
        )}
        <Box style={{ marginTop: "60px" }}>
          {generalData.billing_step_name === "Invoice" &&
            window.location.pathname.includes("/invoice") ? (
            <NextStep
              message={nextStepMessage}
              shootDate={startDate}
              daysAway={daysAway}
            />
          ) : null}
        </Box>
      </Box>
    </Box>
  )
}

export default InvoiceRight
